const base = {
    host: 'https://pbl.zdw000.com',
    project: '/api/ycsj_pbl_program',
    scratch: '/scratch3.0',
    phone: '/phone'
}
export default base